/**
 * Permission codes of the discount engine (`server/internal/discount/permissions.go`).
 *
 * The codes are the server's, character for character: a screen gated on a code
 * the server does not grant would hide itself from everybody. Two pairs are
 * declared segregation-of-duties conflicts on the server (manage x approve for the
 * matrix and for margin floors), so no screen here ever requires both.
 */
export const DISCOUNT_PERMISSIONS = {
  /** View discount types, the authority matrix and the cumulative ceiling. */
  read: 'sales.discount.read',
  /** Draft and submit matrix versions; maintain discount types and the ceiling. */
  matrixManage: 'sales.discount.matrix.manage',
  /** Decide a matrix version or a ceiling loosening (Finance, step-up MFA). */
  matrixApprove: 'sales.discount.matrix.approve',
  /** Draft, edit and submit margin floors. */
  marginFloorManage: 'sales.margin_floor.manage',
  /** Decide a margin floor (Finance, step-up MFA). */
  marginFloorApprove: 'sales.margin_floor.approve',
  /** See margin floors and the resulting margin of a validated line. */
  marginRead: 'sales.margin.read',
  /** See an item's unit cost in a validation result. */
  unitCostRead: 'sales.unit_cost.read',
  /** Run the read-only validation of a proposed discount. */
  validate: 'sales.discount.validate',
} as const

/** Lookup permissions the pickers on these screens depend on (each optional). */
export const DISCOUNT_LOOKUP_PERMISSIONS = {
  /** `GET /roles` — the role picker; without it role codes are typed. */
  roleList: 'admin.role.list',
  /** `GET /crm-account-segments` — the segment picker. */
  segmentRead: 'crm.account.read',
  /** `GET /pricing/categories` — the category picker. */
  categoryRead: 'pricing.price.read',
} as const
